import { CustomUseMutationOptions } from "@/shared/lib/react-query/react-query.lib"
import { clickAlarm, pushAlarm } from "./notification.api"
import { useMutation } from "@tanstack/react-query"

export const usePushAlarmMutation = ({
  onSuccess,
  onError,
  onSettled,
}: CustomUseMutationOptions) => {
  return useMutation({
    mutationFn: pushAlarm,
    onSuccess: () => {
      if (onSuccess) onSuccess()
    },
    onError,
    onSettled,
  })
}

export const useClickAlarmMutation = ({
  onSuccess,
  onError,
  onSettled,
}: CustomUseMutationOptions) => {
  return useMutation({
    mutationFn: clickAlarm,
    onSuccess: () => {
      if (onSuccess) onSuccess()
    },
    onError,
    onSettled,
  })
}
